import styled from '@emotion/styled';

import { baseInputStyles } from '../BaseInput.styled';

export const StyledInput = styled.input`
  ${props => baseInputStyles(props)}
`;
